import { observer } from 'mobx-react';

import { makeStyles } from '@bequestinc/wui';
import MenuIcon from '@mui/icons-material/Menu';
import { Button, Divider, IconButton, MenuItem, MenuList, Paper } from '@mui/material';

import { useGlobalContext } from 'hooks';
import useZygoatEnvVariables from 'hooks/query-hooks/useZygoatEnvVariables';
import { useCurrentUserQuery, useCurrentUserUtils } from 'hooks/query-hooks/users/useUserQuery';

import { ATTORNEY_MENU_ITEMS, PANEL_MENU_ITEMS } from 'utils/constants';

import FloatingUIPopper from 'components/FloatingUIPopper';

const useStyles = makeStyles()(theme => ({
  root: {
    background: theme.palette.common.white,
    zIndex: theme.zIndex.tooltip,
  },
  button: {
    justifyContent: 'left',
    height: '100%',
    width: '100%',
    '&:hover': {
      background: 'none',
    },
  },
}));

const NavMenu = () => {
  const { classes } = useStyles();
  const { firm } = useGlobalContext();

  const { data: user } = useCurrentUserQuery();
  const { logoutUser } = useCurrentUserUtils();
  const { LOGIN_SETTINGS_URL } = useZygoatEnvVariables();

  const loadItems = onClose => {
    if (user.isAttorneyUser && (user.isUnreviewedAttorney || !user.hasRequiredProfile)) return null;
    let items = [];
    if (user.isPanelUser) {
      items = PANEL_MENU_ITEMS.filter(
        item => !item.permissions || user.groups.some(i => item.permissions.includes(i)),
      );
    } else if ((user.isFirmUser || user.isAttorneyUser) && firm.name) {
      items = ATTORNEY_MENU_ITEMS.filter(
        item =>
          (!item.permissions || user.groups.includes(item.permissions)) &&
          (firm.disabledByMalpractice ? item.showIfMalpracticeExpired : true) &&
          (firm.newCasesAllowed || !item.hideIfCantTakeNewCases),
      );
    }
    return (
      <>
        {items.map(({ component, href, description }) => (
          <MenuItem onClick={onClose} key={description}>
            <Button component={component} className={classes.button} href={href}>
              {description}
            </Button>
          </MenuItem>
        ))}
        <Divider />
      </>
    );
  };

  const renderAnchorElement = toggleElementProps => {
    return (
      <IconButton edge="end" aria-label="menu" size="large" {...toggleElementProps}>
        <MenuIcon />
      </IconButton>
    );
  };

  const renderContent = ({ setIsOpen }) => {
    const onClose = () => setIsOpen(false);

    return (
      <Paper variant="outlined">
        <MenuList autoFocus>
          {loadItems(onClose)}
          <MenuItem onClick={onClose}>
            <Button
              className={classes.button}
              onClick={() => {
                window.location = LOGIN_SETTINGS_URL;
              }}
            >
              Login Settings
            </Button>
          </MenuItem>
          <MenuItem onClick={onClose}>
            <Button className={classes.button} onClick={logoutUser}>
              Sign Out
            </Button>
          </MenuItem>
        </MenuList>
      </Paper>
    );
  };

  return (
    <FloatingUIPopper renderAnchorElement={renderAnchorElement} renderContent={renderContent} />
  );
};

NavMenu.propTypes = {};

export default observer(NavMenu);
